import { TopBarProps } from '~/components/TopBar/models';
import { InfoBar } from '~/mappers/infoBar/models';

export const infoBarMapper = ({
  messages,
  ariaLabels,
  showInfoBar,
  isShoppingCartPage,
  isVisibleOnCartPage,
  changeInterval,
}: InfoBar): TopBarProps => ({
  messages,
  ariaLabels,
  showInfoBar: isShoppingCartPage
    ? showInfoBar && messages.length > 0 && isVisibleOnCartPage
    : showInfoBar && messages.length > 0,
  intervalTime:
    changeInterval && changeInterval.length > 0
      ? Number(changeInterval)
      : undefined,
});
